import { protectedPaths } from "@/config";

export function isProtectedRoute (currentPath: string) {
  return protectedPaths.some(path => currentPath.startsWith(path));
};